export const REQUEST_TOKEN_VALIDATE = 'REQUEST_TOKEN_VALIDATE';
export const REQUEST_TOKEN_VALIDATE_RECEIVED = 'REQUEST_TOKEN_VALIDATE_RECEIVED';